import { render, staticRenderFns } from "./CatalogItems.vue?vue&type=template&id=dd569fc8"
import script from "./CatalogItems.vue?vue&type=script&lang=ts"
export * from "./CatalogItems.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CatalogEmotionImage: require('/codebuild/output/src1993466134/src/acredo-website/components/catalog/CatalogEmotionImage.vue').default,CatalogWishlistButton: require('/codebuild/output/src1993466134/src/acredo-website/components/catalog/CatalogWishlistButton.vue').default,CatalogFastDelivery: require('/codebuild/output/src1993466134/src/acredo-website/components/catalog/CatalogFastDelivery.vue').default,Loading: require('/codebuild/output/src1993466134/src/acredo-website/components/Loading.vue').default})
